import PageHome from "../../../active/[pageId]/[name]";
export { getServerSideProps } from "../../../active/[pageId]/[name]";

export default PageHome;
